'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var key = require('interface-datastore/key');

var libp2pRecord = require('libp2p-record');

var errCode = require('err-code');

var debug = require('debug');

var toString = require('uint8arrays/to-string');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = Object.assign(debug__default["default"]('ipfs:ipns:offline-datastore'), {
  error: debug__default["default"]('ipfs:ipns:offline-datastore:error')
});

var OfflineDatastore = /*#__PURE__*/function () {
  function OfflineDatastore(repo) {
    _classCallCheck(this, OfflineDatastore);

    this._repo = repo;
    this.stores = [];
  }

  _createClass(OfflineDatastore, [{
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, value) {
        var routingKey, record;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (key instanceof Uint8Array) {
                  _context.next = 2;
                  break;
                }

                throw errCode__default["default"](new Error('Offline datastore key must be a Uint8Array'), 'ERR_INVALID_KEY');

              case 2:
                if (value instanceof Uint8Array) {
                  _context.next = 4;
                  break;
                }

                throw errCode__default["default"](new Error('Offline datastore value must be a Uint8Array'), 'ERR_INVALID_VALUE');

              case 4:
                _context.prev = 4;
                routingKey = this._routingKey(key);
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](4);
                log.error(_context.t0);
                throw errCode__default["default"](new Error('Not possible to generate the routing key'), 'ERR_GENERATING_ROUTING_KEY');

              case 12:
                record = new libp2pRecord.Record(key, value);
                return _context.abrupt("return", this._repo.datastore.put(routingKey, record.serialize()));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 8]]);
      }));

      function put(_x, _x2) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        var routingKey, res, record;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (key instanceof Uint8Array) {
                  _context2.next = 2;
                  break;
                }

                throw errCode__default["default"](new Error('Offline datastore key must be a Uint8Array'), 'ERR_INVALID_KEY');

              case 2:
                _context2.prev = 2;
                routingKey = this._routingKey(key);
                _context2.next = 10;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](2);
                log.error(_context2.t0);
                throw errCode__default["default"](new Error('Not possible to generate the routing key'), 'ERR_GENERATING_ROUTING_KEY');

              case 10:
                _context2.next = 12;
                return this._repo.datastore.get(routingKey);

              case 12:
                res = _context2.sent;
                _context2.prev = 13;
                record = libp2pRecord.Record.deserialize(res);
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t1 = _context2["catch"](13);
                log.error(_context2.t1);
                throw _context2.t1;

              case 21:
                return _context2.abrupt("return", record.value);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 6], [13, 17]]);
      }));

      function get(_x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "_routingKey",
    value: function _routingKey(key$1) {
      return new key.Key('/' + toString.toString(key$1, 'base32upper'), false);
    }
  }]);

  return OfflineDatastore;
}();

exports.OfflineDatastore = OfflineDatastore;